import { TimeFrame, TimeRange } from "src/components/monitoring/commonTypes";
import { createContext, PropsWithChildren, useContext } from "react";
import dayjs from "dayjs";
import { deDE, enUS, itIT } from "@mui/x-date-pickers";

export type LocaleKey = "en" | "it" | "de";

export const localeTextMap: Record<LocaleKey, typeof deDE.components.MuiLocalizationProvider.defaultProps.localeText> = {
    de: deDE.components.MuiLocalizationProvider.defaultProps.localeText,
    en: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
    it: itIT.components.MuiLocalizationProvider.defaultProps.localeText,
};

export type LabelsTranslations = {
    previous: string;
    next: string;
    start: string;
    end: string;
};

export interface TimeFrameContextProps {
    timeFrame: TimeFrame;
    timeRange: TimeRange;
    onTimeFrameChange: (timeFrame: TimeFrame) => void;
    onTimeRangeChange: (timeRange: TimeRange) => void;
    labels: LabelsTranslations;
    languageLocale: LocaleKey;
}

export const TimeFrameContext = createContext<TimeFrameContextProps>({
    timeFrame: {
        start: dayjs().startOf("day"),
        end: dayjs(),
    },
    timeRange: TimeRange.FREE,
    onTimeFrameChange: () => {},
    onTimeRangeChange: () => {},
    labels: {
        previous: "Previous",
        next: "Next",
        start: "Start",
        end: "End",
    },
    languageLocale: "de" satisfies LocaleKey,
});

export const useTimeData = () => {
    return useContext<TimeFrameContextProps>(TimeFrameContext);
};

export const TimeFrameContextProvider = ({ value, children }: PropsWithChildren<{ value: TimeFrameContextProps }>) => {
    return <TimeFrameContext.Provider value={value}>{children}</TimeFrameContext.Provider>;
};
